import { useEffect } from 'react';
import { useThree, useFrame } from 'react-three-fiber';
import { Vector3 } from 'three';
import lerp from 'lerp';
import { WorldState } from '../App';

type Props = {
  worldState: WorldState;
  setWorldState: (worldState: WorldState) => void;
}

// const STARTING_POSITION = new Vector3(0, 60, -195);
const STARTING_POSITION = new Vector3(270, 15, -5);
const COMPLETE_POSITION = new Vector3(270, 15, -5);
// const COMPLETE_POSITION = new Vector3(0, 60, -95);

const BootScene = ({ worldState, setWorldState }: Props) => {
  const { camera } = useThree();

  useFrame(() => {
    if (worldState === WorldState.STARTING) {
      camera.position.set(STARTING_POSITION.x, STARTING_POSITION.y, STARTING_POSITION.z);
    }
  });

  useEffect(() => {
    if (worldState === WorldState.STARTED) {
      setTimeout(() => {
          setWorldState(WorldState.COMPLETE);
      }, 200);
    }
  });

  useFrame(() => {
    if (worldState === WorldState.STARTED) {
      camera.position.x = lerp(camera.position.x, COMPLETE_POSITION.x, 0.03);
      camera.position.z = lerp(camera.position.z, COMPLETE_POSITION.z, 0.03);
      camera.position.y = lerp(camera.position.y, COMPLETE_POSITION.y, 0.03);
      camera.updateProjectionMatrix();
    }
  });

  return null;
}

export default BootScene;